// Push notifications
export var PRICE = 'price';
export var PRICE_HISTORY = 'price-history';
export var CASHOUT_PRICE = 'cashout_price';
export var EACH_WAY = 'each-way';
export var HANDICAP = 'handicap';
export var STATUS = 'status';
export var IS_IN_PLAY = 'is-in-play';
export var NAME = 'name';
export var ORDER = 'order';
export var DISPLAYED = 'displayed';
export var SETTLED = 'settled';
export var START_DATETIME = 'start-date-time';
export var OFFTIME = 'offtime';
export var MARKET_GROUP = 'market-group';
export var BLURB = 'blurb';
export var SORT = 'sort';
export var HAS_IN_PLAY = 'has-in-play';
export var ACTIVE = 'active';
export var CORRECT_SCORE = 'correct-score';
export var FB_RESULT = 'fb-result';
export var RESULT = 'result';
export var RESULT_CONF = 'resultConf';
export var PLACE = 'place';
export var FOOTBALL = 'FOOTBALL';
export var TENNIS = 'TENNIS';
export var TABLE_TENNIS = 'TABLE_TENNIS';
export var BASKETBALL = 'BASKETBALL';
export var RUGBY = 'RUGBY';
export var SNOOKER = 'SNOOKER';
export var HANDBALL = 'HANDBALL';
export var ICE_HOCKEY = 'ICE_HOCKEY';
export var GENERIC = 'GENERIC';
export var VOLLEYBALL = 'VOLLEYBALL';
export var BASEBALL = 'BASEBALL';
export var FIFA = 'FIFA';
export var DARTS = 'DARTS';
export var CRICKET = 'CRICKET';
export var NOT_STARTED = 'NOT_STARTED';
export var TOTAL = 'TOTAL';
export var HALF_1 = 'HALF_1';
export var QUARTER_1 = 'QUARTER_1';
export var QUARTER_2 = 'QUARTER_2';
export var HALF_2 = 'HALF_2';
export var QUARTER_3 = 'QUARTER_3';
export var QUARTER_4 = 'QUARTER_4';
export var OVERTIME = 'OVERTIME';
export var GAME_FINISHED = 'GAME_FINISHED';
export var FIRST_HALF = 'FIRST_HALF';
export var HALF_TIME = 'HALF_TIME';
export var SECOND_HALF = 'SECOND_HALF';
export var EXTRA_TIME = 'EXTRA_TIME';
export var EXTRA_TIME_NOT_STARTED = 'EXTRA_TIME_NOT_STARTED';
export var FIRST_HALF_EXTRA_TIME = 'FIRST_HALF_EXTRA_TIME';
export var EXTRA_TIME_HALF_TIME = 'EXTRA_TIME_HALF_TIME';
export var SECOND_HALF_EXTRA_TIME = 'SECOND_HALF_EXTRA_TIME';
export var PENALTIES_NOT_STARTED = 'PENALTIES_NOT_STARTED';
export var PENALTIES = 'PENALTIES';
export var UP = 'UP';
export var DOWN = 'DOWN'; // Leg Tracking

export var TRACKING_CLASS = {
  RESULT_ONLY: 'RESULT_ONLY',
  RESULT_SCORE: 'RESULT_SCORE',
  RESULT_TEAM_SCORE: 'RESULT_TEAM_SCORE',
  RESULT_PERIOD_SCORE: 'RESULT_PERIOD_SCORE',
  RESULT_PERIOD_TEAM_SCORE: 'RESULT_PERIOD_TEAM_SCORE',
  FIXED_HANDICAP: 'FIXED_HANDICAP',
  FIXED_HANDICAP_MULTI: 'FIXED_HANDICAP_MULTI',
  HANDICAP: 'HANDICAP',
  FIXED_OVER_UNDER: 'FIXED_OVER_UNDER',
  FIXED_OVER_UNDER_MULTI: 'FIXED_OVER_UNDER_MULTI',
  OVER_UNDER: 'OVER_UNDER',
  PROGRESS_RANGE: 'PROGRESS_RANGE'
};
export var PERIOD = {
  FIRST_HALF: 'FIRST_HALF',
  SECOND_HALF: 'SECOND_HALF',
  FIRST_QUARTER: 'FIRST_QUARTER',
  SECOND_QUARTER: 'SECOND_QUARTER',
  THIRD_QUARTER: 'THIRD_QUARTER',
  FORTH_QUARTER: 'FORTH_QUARTER',
  FIRST_PERIOD: 'FIRST_PERIOD',
  SECOND_PERIOD: 'SECOND_PERIOD',
  THIRD_PERIOD: 'THIRD_PERIOD'
};
export var TRACKING_RESULT = {
  WIN: 'WIN',
  LOSE: 'LOSE',
  VOID: 'VOID'
};
export var TRACKING_TYPE = {
  HOME: 'home',
  AWAY: 'away',
  TIE: 'tie',
  OVER: 'over',
  UNDER: 'under'
};
export var MARKET_LABEL = {
  GOALS: 'GOALS',
  CORNERS: 'CORNERS',
  CARDS: 'CARDS',
  YELLOW_CARDS: 'YELLOW_CARDS',
  RED_CARDS: 'RED_CARDS',
  BOOKING_POINTS: 'BOOKING_POINTS',
  SHOTS: 'SHOTS',
  SHOTS_ON_TARGET: 'SHOTS_ON_TARGET',
  TACKLES: 'TACKLES',
  PENALTIES: 'PENALTIES',
  ASSISTS: 'ASSISTS'
}; // Subscription logic

export var SUBSCRIBE = 'wh.push.subscribe';
export var UNSUBSCRIBE = 'wh.push.unsubscribe';
export var UNSUBSCRIBE_ALL = 'wh.push.unsubscribe-all';
export var PUSH_COMPONENT_READY = 'wh.push.ready';
export var SPORTS = 'sports';
export var LIVE_SCORE = 'livescore';
export var TRACKING = 'tracking';
export var BYO_PRICE_UPDATES = 'byo-price-updates';
export var BYO_EVENT_UPDATES = 'byo-event-updates';
export var GTP_IMPACTSUB = 'gtp-impactsub';
export var GTP_MAINLINES = 'gtp-mainlines';
export var GTP_ENHANCED_ODDS = 'gtp-enhanced-odds';
export var REPLACEMENTS = 'replacements-publisher';
export var PM_IP_TRANSITION_REASON = 'PM_IP_TRANSITION';
export var MOCKED_PUSH_COMPONENT = 'mockedPushComponent';
export var MOCK_SPORTS_UPDATE = 'wh.push.mock.sports';
export var MOCK_LIVESCORE_UPDATE = 'wh.push.mock.livescores';
export var MOCK_TRACKING_UPDATE = 'wh.push.mock.tracking';
export var MOCK_GTP_IMPACTSUB_UPDATE = 'wh.push.mock.gtp.impactsub';
export var MOCK_GTP_MAINLINES_UPDATE = 'wh.push.mock.gtp.mainlines';
export var MOCK_GTP_ENHANCED_ODDS_UPDATE = 'wh.push.mock.gtp.enhancedodds'; // Field maps

export var SPORTS_FIELDMAP = {
  event: ['order', 'displayed', 'isInPlay', 'status', 'settled', 'startDateTime', 'active', 'offtime'],
  market: ['order', 'displayed', 'name', 'status', 'hcapValue', 'marketGroupId', 'blurb', 'sort', 'eachWay', 'eachWayPlaces', 'eachWayFactorNum', 'eachWayFactorDen', 'marketGroupCollectionId', 'hasInPlay', 'active', 'settled'],
  selection: ['order', 'displayed', 'status', 'currentPriceNum', 'currentPriceDen', 'cashoutPriceNum', 'cashoutPriceDen', 'name', 'csHome', 'csAway', 'fbResult', 'settled', 'result', 'resultConf', 'place', 'priceHistory']
}; // Service Updates

export var SERVICE_UPDATES = 'SERVICE_UPDATES';